import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import ThemeContext from '../contexts/ThemeContext';
import { authSelector, clearState, loginUser, microsoftSSOLogin } from '../redux/AuthSlice';
import { loginRequest } from '../msal-config';
import appLogo from '../assets/images/Logo-01.svg';


const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loginAppLogo, loginPageType } = useContext(ThemeContext);
    const { isSuccess, isError, errorMessage } = useSelector(authSelector);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [rememberMe, setRememberMe] = useState(false);

    const { instance } = useMsal();

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(loginUser({ email, password, rememberMe }));
    };

    const handleMicrosoftLogin = async () => {
        try {
            const response = await instance.loginPopup(loginRequest);
            const idToken = response.idToken;
            dispatch(microsoftSSOLogin({ idToken, rememberMe }))
                .unwrap()
                .then(() => console.log('SSO login successful'))
                .catch((err) => console.error('SSO login failed:', err));
        } catch (error) {
            console.error('Microsoft Login Error:', error);
        }
    };

    const handleSignOut = async () => {
        try {
            await instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
        } catch (error) {
            console.error("Sign-out Error:", error);
        }
    };

    // Load saved email from localStorage on component mount
    useEffect(() => {
        const savedEmail = localStorage.getItem('rememberedEmail');
        const savedRememberMe = localStorage.getItem('rememberMeChecked');

        if (savedEmail && savedRememberMe === 'true') {
            setEmail(savedEmail);
            setRememberMe(true);
        }

        return () => {
            dispatch(clearState());
        };
    }, []);

    useEffect(() => {
        if (loginPageType === 'basic') document.body.classList.add('login-page');
        return () => document.body.classList.remove('login-page');
    }, [loginPageType]);

    useEffect(() => {
        if (isError) {
            setMessage(errorMessage);
            dispatch(clearState());
        }

        if (isSuccess) {
            // Save email to localStorage if remember me is checked
            if (rememberMe && email) {
                localStorage.setItem('rememberedEmail', email);
                localStorage.setItem('rememberMeChecked', 'true');
            } else {
                // Clear saved email if remember me is not checked
                localStorage.removeItem('rememberedEmail');
                localStorage.removeItem('rememberMeChecked');
            }

            dispatch(clearState());
            navigate('/');
        }
    }, [isError, isSuccess, rememberMe, email, navigate, dispatch]);

    return (
        <div
            style={{
                backgroundImage: 'url("/images/your-background.png")',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Roboto, sans-serif',
            }}
        >
            <img
                src={loginAppLogo || appLogo}
                alt="Nucleus Logo"
                style={{ height: '112px',width: '344.9PX', marginBottom: '10px' }}
            />

            <form
                className="auth-form"
                style={{
                    backgroundColor: 'rgba(10, 24, 58, 0.2)', 
                    border: '1px solid #2e508d',
                    borderRadius: '20px',
                    
                    height:'408px',
                    width: '344.9PX',
                    maxWidth: '420px',
                    color: '#fdfcff',
                }}
                onSubmit={handleSubmit}
                autoComplete="off"
            >
                <h1 style={{ fontSize: '21px', marginBottom: '20px' }}>Sign in</h1>

                <div className="form-group mb-4">
                    <input
                        type="email"
                        placeholder="Email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{
                            backgroundColor: '#0a183a',
                            border: '1px solid #2e508d',
                            borderRadius: '8px',
                            padding: '16px',
                            color: '#92bbc5',
                            fontSize: '11px',
                            outline: 'none',
                        }}
                        onFocus={(e) => (e.target.style.boxShadow = '0 0 0 1px #2e508d')}
                        onBlur={(e) => (e.target.style.boxShadow = 'none')}
                    />
                </div>

                <div className="form-group mb-4">
                    <input
                        type="password"
                        placeholder="Password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                            backgroundColor: '#0a183a',
                            border: '1px solid #2e508d',
                            borderRadius: '8px',
                            padding: '16px',
                            color: '#92bbc5',
                            fontSize: '11px',
                            outline: 'none',
                        }}
                        onFocus={(e) => (e.target.style.boxShadow = '0 0 0 1px #2e508d')}
                        onBlur={(e) => (e.target.style.boxShadow = 'none')}
                    />
                </div>

                {message && (
                    <p style={{ color: 'red', fontSize: '13px', marginBottom: '15px' }}>{message}</p>
                )}

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <label
                        style={{
                            fontSize: '9px',
                            color: '#92bbc5',
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: 0,
                        }}
                    >
                       <input
  type="checkbox"
  id="remember"
  checked={rememberMe}
  style={{
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    width: '14px',
    height: '14px',
    backgroundColor: '#0a183a',
    border: '1px solid #2e508d',
    borderRadius: '2px',
    position: 'relative',
    marginRight: '6px',
    cursor: 'pointer',
  }}
  onChange={(e) => {
    const checked = e.target.checked;
    setRememberMe(checked);
    if (checked) {
      e.target.style.backgroundColor = '#2e508d';
      e.target.style.backgroundImage =
        "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'><path fill='white' d='M6.1 10.9L3.2 8l-1.4 1.4 4.3 4.3L14.2 5.6l-1.4-1.4z'/></svg>\")";
      e.target.style.backgroundRepeat = 'no-repeat';
      e.target.style.backgroundPosition = 'center';
      e.target.style.backgroundSize = '12px 12px';
    } else {
      e.target.style.backgroundColor = '#0a183a';
      e.target.style.backgroundImage = 'none';
      // Clear saved email immediately if unchecked
      localStorage.removeItem('rememberedEmail');
      localStorage.removeItem('rememberMeChecked');
    }
  }}
/>


                        Remember me
                    </label>

                    <Link
                        to="/forgot-password"
                        style={{
                            fontSize: '9px',
                            color: '#92bbc5',
                            textDecoration: 'none',
                            marginBottom: 0,
                        }}
                    >
                        Forgot Password?
                    </Link>
                </div>

                <div className="form-group mb-4">
                    <button
  type="submit"
  className="btn btn-block"
  style={{
    backgroundColor: '#0a183a',
    border: '1px solid #2e508d',
    borderRadius: '8px',
    color: '#7bc4ff',
    fontSize: '12px',
    width: '100%',
    padding: '10px 0',
    textAlign: 'center',
    lineHeight: '1.4',
    display: 'block',
  }}
>
  Sign in
</button>

                </div>

                <div className="form-group mb-4">
                    <button
                        type="button"
                        className="btn btn-block"
                        onClick={handleMicrosoftLogin}
                        style={{
                            backgroundColor: '#0a183a',
                            border: '1px solid #7bc4ff',
                            borderRadius: '8px',
                            color: '#7bc4ff',
                            fontSize: '12px',
                            width: '100%',
                            padding: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <img
                            src="assets/images/transparent.png"
                            alt="Microsoft"
                            style={{ width: '18px', height: '18px', marginRight: '8px' }}
                        />
                        Sign in with Microsoft
                    </button>
                </div>

                {instance.getAllAccounts().length > 0 && (
                    <p
                        onClick={handleSignOut}
                        style={{
                            fontSize: '9px',
                            color: '#92bbc5',
                            textAlign: 'center',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                        }}
                    >
                        Sign out and login with a different account
                    </p>
                )}
            </form>
        </div>
    );
};

export default Login;
